var _path, _path2, _rect, _rect2, _rect3, _rect4, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvancedSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#85cbf8",
    d: "M5 11H57V57H5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed7899",
    d: "M9,51H53a4,4,0,0,1,4,4v1a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V55a4,4,0,0,1,4-4Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 11,
    x: 5,
    y: 11,
    fill: "#ace3ff",
    rx: 3,
    ry: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 12,
    x: 13,
    y: 5,
    fill: "#ffefb8",
    rx: 2,
    ry: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 12,
    x: 29,
    y: 5,
    fill: "#ffefb8",
    rx: 2,
    ry: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 12,
    x: 45,
    y: 5,
    fill: "#ffefb8",
    rx: 2,
    ry: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9fddff",
    d: "M8.5 33L9.74 35.26 12 36.5 9.74 37.74 8.5 40 7.26 37.74 5 36.5 7.26 35.26 8.5 33zM36.42 26L37.27 27.56 38.84 28.42 37.27 29.27 36.42 30.84 35.56 29.27 34 28.42 35.56 27.56 36.42 26zM50.35 42L50.94 43.06 52 43.65 50.94 44.23 50.35 45.3 49.77 44.23 48.7 43.65 49.77 43.06 50.35 42z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M11 24a1 1 0 0 0 1-1V21a1 1 0 1 0-2 0v2A1 1 0 0 0 11 24zM16 24a1 1 0 0 0 1-1V21a1 1 0 0 0-2 0v2A1 1 0 0 0 16 24zM21 24a1 1 0 0 0 1-1V21a1 1 0 0 0-2 0v2A1 1 0 0 0 21 24zM26 24a1 1 0 0 0 1-1V21a1 1 0 0 0-2 0v2A1 1 0 0 0 26 24zM31 24a1 1 0 0 0 1-1V21a1 1 0 0 0-2 0v2A1 1 0 0 0 31 24zM36 24a1 1 0 0 0 1-1V21a1 1 0 0 0-2 0v2A1 1 0 0 0 36 24zM41 24a1 1 0 0 0 1-1V21a1 1 0 0 0-2 0v2A1 1 0 0 0 41 24zM46 24a1 1 0 0 0 1-1V21a1 1 0 0 0-2 0v2A1 1 0 0 0 46 24zM51 24a1 1 0 0 0 1-1V21a1 1 0 0 0-2 0v2A1 1 0 0 0 51 24zM53 50H9a1 1 0 0 0 0 2H53a1 1 0 0 0 0-2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d6c9f",
    d: "M55,10H50V7a3,3,0,0,0-6,0v3H34V7a3,3,0,0,0-6,0v3H18V7a3,3,0,0,0-6,0v3H7a3,3,0,0,0-3,3V55a3,3,0,0,0,3,3H55a3,3,0,0,0,3-3V13A3,3,0,0,0,55,10ZM46,7a1,1,0,0,1,2,0v8a1,1,0,0,1-2,0ZM30,7a1,1,0,0,1,2,0v8a1,1,0,0,1-2,0ZM14,7a1,1,0,0,1,2,0v8a1,1,0,0,1-2,0ZM56,55a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V24a1,1,0,0,0,1-1V21a1,1,0,0,0-1-1V13a1,1,0,0,1,1-1h5v3a3,3,0,0,0,6,0V12H28v3a3,3,0,0,0,6,0V12H44v3a3,3,0,0,0,6,0V12h5a1,1,0,0,1,1,1v7a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35 34H47a1 1 0 0 0 0-2H35a1 1 0 0 0 0 2zM26 33a1 1 0 0 0 1 1h4a1 1 0 0 0 0-2H27A1 1 0 0 0 26 33zM26 41a1 1 0 0 0 1 1H43a1 1 0 0 0 0-2H27A1 1 0 0 0 26 41zM16.29 35.71a1 1 0 0 0 1.41 0l4-4a1 1 0 0 0-1.41-1.41L17 33.59l-1.29-1.29a1 1 0 0 0-1.41 1.41zM16.29 43.71a1 1 0 0 0 1.41 0l4-4a1 1 0 0 0-1.41-1.41L17 41.59l-1.29-1.29a1 1 0 0 0-1.41 1.41z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancedSchedule);
export default __webpack_public_path__ + "static/media/advancedSchedule.fe0e1f34311880c41db8ee1883cd3858.svg";
export { ForwardRef as ReactComponent };